import { create } from 'zustand';

import { Fdd } from '@/types/fdd.type';

export interface FddState {
  fdd: Fdd | undefined;
  setFdd: (fdd: Fdd) => void;
}

export const useFddStore = create<FddState>((set) => ({
  fdd: undefined,
  setFdd: (fdd: Fdd) => set(() => ({ fdd })),
}));
